export const validateCorporateNumber = (corporateNumber: string | null | undefined): string => {
  if (!corporateNumber) {
    return '入力してください';
  }

  if (!/^[0-9]{13}$/.test(corporateNumber)) {
    return '13桁の半角数字で入力してください';
  }

  const checkDigit = calcCorporateNumberCheckDigit(corporateNumber.slice(1));
  if (corporateNumber[0] !== checkDigit) {
    return '入力が誤っています';
  }

  return '';
};

const calcCorporateNumberCheckDigit = (corporateNumber12Digit: string): string => {
  if (corporateNumber12Digit?.length !== 12) {
    return '';
  }

  const array = Array.from(corporateNumber12Digit);

  let evenSum = 0;
  let oddSum = 0;

  for (let index = 0; index < array.length; index++) {
    const num = parseInt(array[index]);
    if (index % 2 === 0) {
      evenSum += num;
    } else {
      oddSum += num;
    }
  }

  const sum = evenSum * 2 + oddSum;
  const remainder = sum % 9;
  const checkDigit = 9 - remainder;

  return checkDigit.toString();
};
